import React, { useEffect, useState } from "react";
import { InputBox, Password } from "../../components/CustomWidgets/InputBox";
import SelectBox from "../CustomWidgets/SelectBox";
import UploadMediaonly from "../upload-imageonly";
import {
  createStoreUser,
  getStoreUsers,
  updateStoreUser,
  UserImageUpload,
} from "../../API  Functions/UserMangement";
import "../../styles.css";
import UsermanagementPopup from "../../Popups/usermanagementPopup";
import { useSelector } from "react-redux";
import { addUserSchema } from "../validationSchema";
import { useTranslation } from "react-i18next";
import image from "../../assets/Images/roundimage.png";
import LoadingSpinner from "../Loading";
import { toast } from "react-toastify";
import { DoubleRightOutlined } from "@ant-design/icons";
import { Breadcrumb } from "antd";
import { routes } from "../../Routes";
import { Link } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import {
  GetOrderFrom,
  GetPaymentMethods,
  GetSelectedMethods,
  updateOrderFrom,
  updatePaymentModes,
  updateUserRights,
} from "../../API  Functions/CashierSetup";
import {
  GetRetailerDetails,
  UpdateRetailerDetails,
} from "../../API  Functions/ProfileFunctions";
import {
  getInventoryEditResttriction,
  uploadImage,
} from "../../API  Functions/InventoryFunctions";
import UserRightsTable from "./UserRightsTable";
import { createRoot } from "react-dom/client";
import InventoryOnboardPopup from "../../Popups/InventoryOnboardPopup";
import { checkPermission } from "../../Utils/permissionHelper";
import SearchBox from "../CustomWidgets/SearchBox";

const CashierModulesAccess = () => {
  const { t, i18n } = useTranslation();

  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );
  const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  const [allUsers, setAllUsers] = useState([]); // 🔹 backup for search
  const [isEtaEnable, setIsEtaEnable] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const isRTL = i18n.language === "ar";
  const [passwordModal, setPasswordModal] = useState({
    open: false,
    userId: null,
    value: "",
  });
  useEffect(() => {
    GetUserData();
    CheckUserAcessForInventory();
  }, []);

  const CheckUserAcessForInventory = async () => {
    try {
      const res = await getInventoryEditResttriction(user_id);
      if (res?.result?.status_code == 200) {
        setIsEtaEnable(res?.result?.is_eta_enabled);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const GetUserData = async () => {
    try {
      const res = await getStoreUsers(user_id);

      if (res?.result[0]?.status_code === 200) {
        const activeUsers = res.result[0]?.response?.filter(
          (user) => user.active === true && user.user_type !== "online_sale",
        );

        setUserData(activeUsers);
        setAllUsers(activeUsers);
        setSelectedUser(activeUsers[0] || null);
      } else {
        setUserData([]);
        setAllUsers([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCheckboxChange = (id, field, value) => {
    const updated = userData.map((user) =>
      user.retailer_user_id === id ? { ...user, [field]: value } : user,
    );

    setUserData(updated);

    // update selected user also
    const updatedSelected = updated.find((u) => u.retailer_user_id === id);
    setSelectedUser(updatedSelected);
  };

  const handlePasswordChange = (id, value) => {
    const updatedData = userData?.map((item) =>
      item.retailer_user_id === id ? { ...item, pos_password: value } : item,
    );
    setUserData(updatedData);
    setAllUsers(updatedData);
  };

  const UpdateUserRights = async () => {
    setLoading(true);
    const payload = {
      user_id: user_id,
      retailer_users: userData?.map((user) => ({
        user_id: user.retailer_user_id, // or user.user_id, depending on your structure
        is_dashboard_show: user.is_dashboard_show,
        is_password_restrict: user.is_password_restrict,
        show_orders: user.show_orders,
        show_credit: user.show_credit,
        pos_password: user.pos_password,
        is_favorite_show: user.is_favorite_show,
        is_all_categ_show: user.is_all_categ_show,
        is_allow_discount: user?.is_allow_discount,
        is_allow_product_shortcut: user?.is_allow_product_shortcut,
        is_allow_opening_cash: user?.is_allow_opening_cash,
        is_allow_negative_sale: user?.is_allow_negative_sale,
        is_allow_add_product: user?.is_allow_add_product,
        is_allow_edit_product_group: user?.is_allow_edit_product_group,
        is_tax_price_inclusive: user?.is_tax_price_inclusive,
        is_show_total_credit: user?.is_show_total_credit,
        is_allow_sale_price_edit: user?.is_allow_sale_price_edit,
        is_show_customers: user?.is_show_customers,
        is_show_product_quantity: user?.is_show_product_quantity,
        is_allow_bill_discount: user?.is_allow_bill_discount,
        is_allow_check_stock:user?.is_allow_check_stock
      })),
    };
    try {
      const res1 = await updateUserRights(payload);
      if (res1?.result[0]?.status_code == 200) {
        showModal("");
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const showModal = (message) => {
    const modalContainer = document.createElement("div");
    document.body.appendChild(modalContainer);

    const root = createRoot(modalContainer);

    const handleClose = () => {
      root.unmount(); // Unmount the React component
      document.body.removeChild(modalContainer); // Remove the container from the DOM
    };

    root.render(
      <InventoryOnboardPopup message={message} onClose={handleClose} />,
    );
  };

  const searchUser = (searchText) => {
    console.log("searchText==>", searchText);

    if (!searchText || searchText.trim() === "") {
      setUserData(allUsers); // reset when empty
      return;
    }

    const text = searchText.toLowerCase();

    const filteredUsers = allUsers.filter((user) => {
      const name =
        typeof user?.name === "string" ? user.name.toLowerCase() : "";
      const email =
        typeof user?.email === "string" ? user.email.toLowerCase() : "";
      const phone =
        typeof user?.phone === "string" ? user.phone.toLowerCase() : "";

      return (
        name.includes(text) || email.includes(text) || phone.includes(text)
      );
    });

    setUserData(filteredUsers);
  };
  const handlePasswordSave = (userId, password) => {
    const updated = userData.map((user) =>
      user.retailer_user_id === userId
        ? {
            ...user,
            is_password_restrict: true,
            pos_password: password,
          }
        : user,
    );

    setUserData(updated);

    const updatedSelected = updated.find((u) => u.retailer_user_id === userId);
    setSelectedUser(updatedSelected);
  };
  const handlePasswordRemove = (userId) => {
    const updated = userData.map((user) =>
      user.retailer_user_id === userId
        ? {
            ...user,
            is_password_restrict: false,
            pos_password: "",
          }
        : user,
    );

    setUserData(updated);

    const updatedSelected = updated.find((u) => u.retailer_user_id === userId);
    setSelectedUser(updatedSelected);
  };
  return (
    <div>
      {loading && <LoadingSpinner />}
      {passwordModal.open && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg w-[350px] shadow-lg">
            <h2 className="text-lg font-semibold mb-4">
              {t("Set Security Password")}
            </h2>

            <input
              type="text"
              value={passwordModal.value}
              onChange={(e) =>
                setPasswordModal((prev) => ({
                  ...prev,
                  value: e.target.value,
                }))
              }
              placeholder={t("Enter Password")}
              className="w-full border border-gray-300 rounded px-3 py-2 mb-4"
            />

            <div className="flex justify-end gap-3">
              <button
                onClick={() =>
                  setPasswordModal({ open: false, userId: null, value: "" })
                }
                className="px-4 py-2 border rounded-lg text-primaryBlue"
              >
                {t("Cancel")}
              </button>

              <button
                onClick={() => {
                  handlePasswordSave(passwordModal.userId, passwordModal.value);
                  setPasswordModal({ open: false, userId: null, value: "" });
                }}
                className="px-4 py-2 bg-primaryBlue text-white rounded-lg"
              >
                {t("Save")}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* HEADER */}
      <div className="flex flex-col md:flex-row justify-between md:items-center mb-4">
        <SearchBox
          searchResult={(values) => searchUser(values)}
          placeholder={t("Search Users")}
        />

        <button
          onClick={UpdateUserRights}
          className="mt-4 md:mt-0 w-36 h-10 rounded-lg font-semibold bg-primaryBlue text-white"
        >
          {t("Save")}
        </button>
      </div>

      {/* MAIN LAYOUT */}
      <div className="flex gap-1 md:gap-5">
        {/* LEFT - USER LIST */}
        <div className="w-5/12 md:w-1/4 bg-white rounded-lg h-[550px] overflow-y-auto">
          <div className="space-y-1">
            {userData.map((user) => (
              <div
                key={user.retailer_user_id}
                onClick={() => setSelectedUser(user)}
                className={`p-2 rounded-lg cursor-pointer ${
                  selectedUser?.retailer_user_id === user.retailer_user_id
                    ? `bg-blue-100 ${
                        isRTL
                          ? "border-r-4 border-primaryBlue"
                          : "border-l-4 border-primaryBlue"
                      }`
                    : "hover:bg-gray-100"
                }`}
              >
                <p className="text-xs md:text-md font-medium">{user.name}</p>
                <p className="text-xs text-gray-500">
                  {user.email || user.phone}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT - PERMISSIONS */}
        <div className="w-3/4 bg-white rounded-lg p-2 md:p-5">
          {selectedUser ? (
            <>
              <h2 className="text-lg font-semibold mb-4">
                {selectedUser.name}
              </h2>

              {/* 🔥 GRID 2 PER ROW */}
            
              <div className="grid grid-col-1 md:grid-cols-2 gap-4">
{/* Dashboard */}
<ToggleRow
  label="Dashboard"
  description="Allows the cashier to access and view the dashboard."
  value={selectedUser.is_dashboard_show}
  onChange={(val) =>
    handleCheckboxChange(
      selectedUser.retailer_user_id,
      "is_dashboard_show",
      val,
    )
  }
/>

{/* Orders */}
<ToggleRow
  label="View Orders"
  description="Allows the cashier to view all customer orders."
  value={selectedUser.show_orders}
  onChange={(val) =>
    handleCheckboxChange(
      selectedUser.retailer_user_id,
      "show_orders",
      val,
    )
  }
/>

{/* Credit */}
<ToggleRow
  label="Credit"
  description="Allows sales on customer credit and access to credit transactions."
  value={selectedUser.show_credit}
  onChange={(val) =>
    handleCheckboxChange(
      selectedUser.retailer_user_id,
      "show_credit",
      val,
    )
  }
/>

{/* Favorites */}
<ToggleRow
  label="Favorites"
  description="Allows quick access to favorite products."
  value={selectedUser.is_favorite_show}
  onChange={(val) =>
    handleCheckboxChange(
      selectedUser.retailer_user_id,
      "is_favorite_show",
      val,
    )
  }
/>

{/* Category */}
<ToggleRow
  label="All Category"
  description="Displays all product categories in the POS."
  value={selectedUser.is_all_categ_show}
  onChange={(val) =>
    handleCheckboxChange(
      selectedUser.retailer_user_id,
      "is_all_categ_show",
      val,
    )
  }
/>

{/* Discount */}
<ToggleRow
  label="Discount"
  description="Allows discounts on individual products."
  value={selectedUser.is_allow_discount}
  onChange={(val) =>
    handleCheckboxChange(
      selectedUser.retailer_user_id,
      "is_allow_discount",
      val,
    )
  }
/>

{/* Product Shortcut */}
<ToggleRow
  label="Product Shortcut"
  description="Shows searching product shortcuts for faster billing."
  value={selectedUser.is_allow_product_shortcut}
  onChange={(val) =>
    handleCheckboxChange(
      selectedUser.retailer_user_id,
      "is_allow_product_shortcut",
      val,
    )
  }
/>

{/* Opening Cash */}
<ToggleRow
  label="Opening Cash"
  description="Allows entering the opening cash amount."
  value={selectedUser.is_allow_opening_cash}
  onChange={(val) =>
    handleCheckboxChange(
      selectedUser.retailer_user_id,
      "is_allow_opening_cash",
      val,
    )
  }
/>

{/* Negative Sale */}
<ToggleRow
  label="Allow Negative Sale"
  description="Allows selling products even when stock is unavailable in the system."
  value={selectedUser.is_allow_negative_sale}
  onChange={(val) =>
    handleCheckboxChange(
      selectedUser.retailer_user_id,
      "is_allow_negative_sale",
      val,
    )
  }
/>

{/* Add Product */}
<ToggleRow
  label="Allow Add Product (Cashier)"
  description="Allows the cashier to add or create new products."
  value={selectedUser.is_allow_add_product}
  onChange={(val) =>
    handleCheckboxChange(
      selectedUser.retailer_user_id,
      "is_allow_add_product",
      val,
    )
  }
/>

 {/* Tax */}
                {/* <ToggleRow
                  label="Tax Price Inclusive"
                  value={selectedUser.is_tax_price_inclusive}
                  onChange={(val) =>
                    handleCheckboxChange(
                      selectedUser.retailer_user_id,
                      "is_tax_price_inclusive",
                      val,
                    )
                  }
                /> */}

{/* Product Group */}
<ToggleRow
  label="Edit Product Group (Cashier)"
  description="Allows the cashier to edit product groups."
  value={selectedUser.is_allow_edit_product_group}
  onChange={(val) =>
    handleCheckboxChange(
      selectedUser.retailer_user_id,
      "is_allow_edit_product_group",
      val,
    )
  }
/>

{/* Total Credit */}
<ToggleRow
  label="Show Total Credit"
  description="Displays the customer's total outstanding credit."
  value={selectedUser.is_show_total_credit}
  onChange={(val) =>
    handleCheckboxChange(
      selectedUser.retailer_user_id,
      "is_show_total_credit",
      val,
    )
  }
/>

{/* Sale Price */}
<ToggleRow
  label="Allow Update Sales Price"
  description="Allows changing the product selling price during billing."
  value={selectedUser.is_allow_sale_price_edit}
  onChange={(val) =>
    handleCheckboxChange(
      selectedUser.retailer_user_id,
      "is_allow_sale_price_edit",
      val,
    )
  }
/>

{/* Customers */}
<ToggleRow
  label="Show All Customers"
  description="Displays the complete customer list."
  value={selectedUser.is_show_customers}
  onChange={(val) =>
    handleCheckboxChange(
      selectedUser.retailer_user_id,
      "is_show_customers",
      val,
    )
  }
/>

{/* Product Quantity */}
<ToggleRow
  label="Show Products Quantity"
  description="Displays available stock quantity for each product."
  value={selectedUser.is_show_product_quantity}
  onChange={(val) =>
    handleCheckboxChange(
      selectedUser.retailer_user_id,
      "is_show_product_quantity",
      val,
    )
  }
/>

{/* Bill Discount */}
<ToggleRow
  label="Allow Bill Discount"
  description="Allows discounts on the entire bill."
  value={selectedUser.is_allow_bill_discount}
  onChange={(val) =>
    handleCheckboxChange(
      selectedUser.retailer_user_id,
      "is_allow_bill_discount",
      val,
    )
  }
/>
<ToggleRow
  label={t("Allow Check Stock")}
  description={t("Allows cashiers to check stock availability across branches.")}
  value={selectedUser.is_allow_check_stock}
  onChange={(val) =>
    handleCheckboxChange(
      selectedUser.retailer_user_id,
      "is_allow_check_stock",
      val,
    )
  }
/>

{/* Password Restriction */}
<ToggleRow
  label="Password Restriction"
  description="Requires a security password for restricted actions."
  value={selectedUser.is_password_restrict}
  onChange={(val) => {
    if (val) {
      setPasswordModal({
        open: true,
        userId: selectedUser.retailer_user_id,
        value: selectedUser.pos_password || "",
      });
    } else {
      handlePasswordRemove(selectedUser.retailer_user_id);
    }
  }}
/>
{/* Bill Discount */}

              </div>
            </>
          ) : (
            <div className="text-center text-gray-400">
              {t("Select a user")}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CashierModulesAccess;

// 🔹 Section Wrapper
const Section = ({ title, children }) => (
  <div>
    <p className="font-semibold mb-3">{title}</p>
    <div className="space-y-3">{children}</div>
  </div>
);

const ToggleRow = ({ label, description, value, onChange }) => {
  const { t } = useTranslation();
  const isRTL = document.dir === "rtl";

  return (
    <div
      className={`flex items-center justify-between bg-gray-100 px-3 md:px-4 py-3 rounded-xl ${
        isRTL ? "flex-row-reverse" : ""
      }`}
    >
      <div className="w-[75%] md:w-[82%]">
        <p className="text-sm md:text-base font-medium">
          {t(label)}
        </p>

        {description && (
          <p className="text-xs md:text-sm text-gray-500 mt-1 leading-5">
            {t(description)}
          </p>
        )}
      </div>

      <div
        onClick={() => onChange(!value)}
        className={`relative w-12 h-6 rounded-full cursor-pointer transition-colors duration-300 ${
          value ? "bg-blue-500" : "bg-gray-300"
        }`}
      >
        <div
          className={`absolute top-1 w-4 h-4 bg-white rounded-full shadow-md transition-all duration-300 ${
            value
              ? isRTL
                ? "right-1"
                : "left-7"
              : isRTL
                ? "left-1"
                : "left-1"
          }`}
        />
      </div>
    </div>
  );
};
